import { useStoreUser } from '~/providers/StoreUserProvider';

/** Represents if the current store is considered "active"; essentially with a non-expired invoice definition. */
export default function useIsActive() {
  const { store } = useStoreUser();

  if (!store.invoiceDefinition) return false;
  const isExpired = new Date(store.invoiceDefinition.endDate) < new Date();

  return !isExpired;
}
